import { uniqBy } from 'es-toolkit';
import type { SaversUserResponse } from './api';

export const normalizeAllUsersList = (list: SaversUserResponse): { label: string; value: number }[] => {
  if (!list) {
    return [];
  }
  const uniqueCoordinators = uniqBy(list, ({ userId }) => userId);
  return uniqueCoordinators.map((row) => ({
    label: row.fullName,
    value: row.userId,
  }));
};
